import { ShipmentsKpisActionTypes } from './constants';

export const INIT_STATE = {
    loadingShipmentsNoShipments: false,
    errorGetShipmentsNoShipments: null,
    shipmentsNoShipments: null,
    loadingShipmentsNoCustomers: false,
    errorGetShipmentsNoCustomers: null,
    shipmentsNoCustomers: null,
    loadingShipmentsTotalCost: false,
    errorGetShipmentsTotalCost: null,
    shipmentsTotalCost: null,
    loadingShipmentsBaseCost: false,
    errorGetShipmentsBaseCost: null,
    shipmentsBaseCost: null,
    loadingShipmentsAvgCost: false,
    errorGetShipmentsAvgCost: null,
    shipmentsAvgCost: null,
    loadingShipmentsAvgShippedWeight: false,
    errorGetShipmentsAvgShippedWeight: null,
    shipmentsAvgShippedWeight: null,
    loadingShipmentsAvgBilledWeight: false,
    errorGetShipmentsAvgBilledWeight: null,
    shipmentsAvgBilledWeight: null,
    loadingShipmentsNoShipmentsByTimeframe: false,
    errorGetShipmentsNoShipmentsByTimeframe: null,
    shipmentsNoShipmentsByTimeframe: null,
    loadingShipments: false,
    errorGetShipments: null,
    shipments: null,
    loadingShipmentsSources: false,
    errorGetShipmentsSources: null,
    shipmentsSources: null,
    loadingShipmentsCarriers: false,
    errorGetShipmentsCarriers: null,
    shipmentsCarriers: null,
    loadingShipmentsDestinations: false,
    errorGetShipmentsDestinations: null,
    shipmentsDestinations: null,
    loadingShipmentsShippedWeights: false,
    errorGetShipmentsShippedWeights: null,
    shipmentsShippedWeights: null,
    loadingShipmentsBilledWeights: false,
    errorGetShipmentsBilledWeights: null,
    shipmentsBilledWeights: null,
    loadingShipmentsCarrierWeights: false,
    errorGetShipmentsCarrierWeights: null,
    shipmentsCarrierWeights: null,
    loadingShipmentsTotalCostByTimeframe: false,
    errorGetShipmentsTotalCostByTimeframe: null,
    shipmentsTotalCostByTimeframe: null,
    errorGetShipmentsCountByZipCode: null,
    loadingShipmentsCountByZipCode: false,
    shipmentsCountByZipCode: null,
    errorGetShipFromLocations: null,
    loadingShipFromLocations: false,
    shipFromLocations: null,
    errorGetAggregatedCostByService: null,
    loadingAggregatedCostByService: false,
    aggregatedCostByService: null,
    loadingShipmentsCarriers: false,
    errorGetShipmentsCarriers: null,
    shipmentsCarriers: null,
};

type ShipmentsKpisAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for shipments
type State = {
    loadingShipmentsNoShipments: Boolean,
    errorGetShipmentsNoShipments: null,
    shipmentsNoShipments: any,
    loadingShipmentsNoCustomers: Boolean,
    errorGetShipmentsNoCustomers: null,
    shipmentsNoCustomers: any,
    loadingShipmentsTotalCost: Boolean,
    errorGetShipmentsTotalCost: null,
    shipmentsTotalCost: any,
    loadingShipmentsBaseCost: Boolean,
    errorGetShipmentsBaseCost: null,
    shipmentsBaseCost: any,
    loadingShipmentsAvgCost: Boolean,
    errorGetShipmentsAvgCost: null,
    shipmentsAvgCost: any,
    loadingShipmentsAvgShippedWeight: Boolean,
    errorGetShipmentsAvgShippedWeight: null,
    shipmentsAvgShippedWeight: any,
    loadingShipmentsAvgBilledWeight: Boolean,
    errorGetShipmentsAvgBilledWeight: null,
    shipmentsAvgBilledWeight: any,
    loadingShipmentsNoShipmentsByTimeframe: Boolean,
    errorGetShipmentsNoShipmentsByTimeframe: null,
    shipmentsNoShipmentsByTimeframe: any,
    loadingShipments: Boolean,
    errorGetShipments: null,
    shipments: any,
    loadingShipmentsSources: Boolean,
    errorGetShipmentsSources: null,
    shipmentsSources: any,
    loadingShipmentsCarriers: Boolean,
    errorGetShipmentsCarriers: null,
    shipmentsCarriers: any,
    loadingShipmentsDestinations: Boolean,
    errorGetShipmentsDestinations: null,
    shipmentsDestinations: any,
    loadingShipmentsShippedWeights: Boolean,
    errorGetShipmentsShippedWeights: null,
    shipmentsShippedWeights: any,
    loadingShipmentsBilledWeights: Boolean,
    errorGetShipmentsBilledWeights: null,
    shipmentsBilledWeights: any,
    loadingShipmentsCarrierWeights: false,
    errorGetShipmentsCarrierWeights: null,
    shipmentsCarrierWeights: any,
    loadingShipmentsTotalCostByTimeframe: false,
    errorGetShipmentsTotalCostByTimeframe: null,
    shipmentsTotalCostByTimeframe: null,
    errorGetShipmentsCountByZipCode?: null,
    loadingShipmentsCountByZipCode: Boolean,
    shipmentsCountByZipCode: any,
    errorGetShipFromLocations: null,
    loadingShipFromLocations: false,
    shipFromLocations: null,
    errorGetAggregatedCostByService: null,
    loadingAggregatedCostByService: false,
    aggregatedCostByService: any,
    loadingShipmentsCarriers: Boolean,
    errorGetShipmentsCarriers: null,
    shipmentsCarriers: any,
};

const ShipmentsKpis = (state: State = INIT_STATE, action: ShipmentsKpisAction): any => {
    switch (action.type) {
        case ShipmentsKpisActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST: {
                    return { ...state, loadingShipmentsNoCustomers: false, shipmentsNoCustomers: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST: {
                    return { ...state, loadingShipmentsNoShipments: false, shipmentsNoShipments: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST: {
                    return { ...state, loadingShipmentsTotalCost: false, shipmentsTotalCost: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST: {
                    return { ...state, loadingShipmentsBaseCost: false, shipmentsBaseCost: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST: {
                    return { ...state, loadingShipmentsAvgCost: false, shipmentsAvgCost: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST: {
                    return { ...state, loadingShipmentsAvgShippedWeight: false, shipmentsAvgShippedWeight: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST: {
                    return { ...state, loadingShipmentsAvgBilledWeight: false, shipmentsAvgBilledWeight: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsNoShipmentsByTimeframe: false, shipmentsNoShipmentsByTimeframe: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_REQUEST: {
                    return { ...state, loadingShipments: false, shipments: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST: {
                    return { ...state, loadingShipmentsSources: false, shipmentsSources: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST: {
                    return { ...state, loadingShipmentsCarriers: false, shipmentsCarriers: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST: {
                    return { ...state, loadingShipmentsDestinations: false, shipmentsDestinations: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST: {
                    return { ...state, loadingShipmentsShippedWeights: false, shipmentsShippedWeights: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST: {
                    return { ...state, loadingShipmentsBilledWeights: false, shipmentsBilledWeights: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST: {
                    return { ...state, loadingShipmentsCarrierWeights: false, shipmentsCarrierWeights: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsTotalCostByTimeframe: false, shipmentsTotalCostByTimeframe: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE: {
                    return { ...state, loadingShipmentsCountByZipCode: false, shipmentsCountByZipCode: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS: {
                    return { ...state, loadingShipFromLocations: false, shipFromLocations: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE: {
                    return { ...state, loadingAggregatedCostByService: false, aggregatedCostByService: action.payload.data };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST: {
                    return { ...state, loadingShipmentsCarriers: false, shipmentsCarriers: action.payload.data };
                }
                default:
                    return { 
                        ...state, 
                        loadingShipmentsNoCustomers: false,
                        loadingShipmentsNoShipments: false,
                        loadingShipmentsTotalCost: false,
                        loadingShipmentsBaseCost: false,
                        loadingShipmentsAvgCost: false,
                        loadingShipmentsAvgShippedWeight: false,
                        loadingShipmentsAvgBilledWeight: false,
                        loadingShipmentsNoShipmentsByTimeframe: false,
                        loadingShipments: false,
                        loadingShipmentsSources: false,
                        loadingShipmentsCarriers: false,
                        loadingShipmentsDestinations: false,
                        loadingShipmentsShippedWeights: false,
                        loadingShipmentsBilledWeights: false,
                        loadingShipmentsCarrierWeights: false,
                        loadingShipmentsTotalCostByTimeframe: false,
                        loadingShipmentsCountByZipCode: false,
                        loadingShipFromLocations: false,
                        loadingAggregatedCostByService: false,
                        loadingShipmentsCarriers: false,
                    };
            }

        case ShipmentsKpisActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST: {
                    return { ...state, loadingShipmentsNoShipments: false, errorGetShipmentsNoShipments: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST: {
                    return { ...state, loadingShipmentsNoCustomers: false, errorGetShipmentsNoCustomers: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST: {
                    return { ...state, loadingShipmentsTotalCost: false, errorGetShipmentsTotalCost: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST: {
                    return { ...state, loadingShipmentsBaseCost: false, errorGetShipmentsBaseCost: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST: {
                    return { ...state, loadingShipmentsAvgCost: false, errorGetShipmentsAvgCost: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST: {
                    return { ...state, loadingShipmentsAvgShippedWeight: false, errorGetShipmentsAvgShippedWeight: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST: {
                    return { ...state, loadingShipmentsAvgBilledWeight: false, errorGetShipmentsAvgBilledWeight: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsNoShipmentsByTimeframe: false, errorGetShipmentsNoShipmentsByTimeframe: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_REQUEST: {
                    return { ...state, loadingShipments: false, errorGetShipments: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST: {
                    return { ...state, loadingShipmentsSources: false, errorGetShipmentsSources: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST: {
                    return { ...state, loadingShipmentsCarriers: false, errorGetShipmentsCarriers: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST: {
                    return { ...state, loadingShipmentsDestinations: false, errorGetShipmentsDestinations: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST: {
                    return { ...state, loadingShipmentsShippedWeights: false, errorGetShipmentsShippedWeights: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST: {
                    return { ...state, loadingShipmentsBilledWeights: false, errorGetShipmentsBilledWeights: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST: {
                    return { ...state, loadingShipmentsCarrierWeights: false, errorGetShipmentsCarrierWeights: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsTotalCostByTimeframe: false, errorGetShipmentsTotalCostByTimeframe: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE: {
                    return { ...state, loadingShipmentsCountByZipCode: false, errorGetShipmentsCountByZipCode: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS: {
                    return { ...state, loadingShipFromLocations: false, errorGetShipFromLocations: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE: {
                    return { ...state, loadingAggregatedCostByService: false, errorGetAggregatedCostByService: action.payload.error };
                }
                case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST: {
                    return { ...state, loadingShipmentsCarriers: false, errorGetShipmentsCarriers: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST:
            return { ...state, loadingShipmentsNoShipments: true, shipmentsNoShipments: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST:
            return { ...state, loadingShipmentsNoCustomers: true, shipmentsNoCustomers: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST:
            return { ...state, loadingShipmentsTotalCost: true, shipmentsTotalCost: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST:
            return { ...state, loadingShipmentsBaseCost: true, shipmentsBaseCost: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST:
            return { ...state, loadingShipmentsAvgCost: true, shipmentsAvgCost: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST:
            return { ...state, loadingShipmentsAvgShippedWeight: true, shipmentsAvgShippedWeight: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST:
            return { ...state, loadingShipmentsAvgBilledWeight: true, shipmentsAvgBilledWeight: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST:
            return { ...state, loadingShipmentsNoShipmentsByTimeframe: true, shipmentsNoShipmentsByTimeframe: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_REQUEST:
            return { ...state, loadingShipments: true, shipments: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST:
            return { ...state, loadingShipmentsSources: true, shipmentsSources: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST:
            return { ...state, loadingShipmentsCarriers: true, shipmentsCarriers: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST:
            return { ...state, loadingShipmentsDestinations: true, shipmentsDestinations: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST:
            return { ...state, loadingShipmentsShippedWeights: true, shipmentsShippedWeights: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST:
            return { ...state, loadingShipmentsBilledWeights: true, shipmentsBilledWeights: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST:
            return { ...state, loadingShipmentsCarrierWeights: true, shipmentsCarrierWeights: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST:
            return { ...state, loadingShipmentsTotalCostByTimeframe: true, shipmentsTotalCostByTimeframe: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE:
            return { ...state, loadingShipmentsCountByZipCode: true, shipmentsCountByZipCode: null };
        case ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS:
            return { ...state, loadingShipFromLocations: true, shipFromLocations: null };
        case ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE:
            return { ...state, loadingAggregatedCostByService: true, aggregatedCostByService: null };
        case ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST:
            return { ...state, loadingShipmentsCarriers: true, shipmentsCarriers: null };
        default:
            return { ...state };
    }
};

export default ShipmentsKpis;
